// The panel's header: the task the list lives in — its title, client, job, who it is
// with and when it is due — and the task's own act beside it. A finished task says when
// it was done and offers to reopen it, which is the only way its list becomes editable.
import he from '../../i18n/he';
import Button from '../Button';
import DateText from '../DateText';

export default function ListPanelHead({ task, onClose, onDefine, onDone, onReopen, onPrint, phone }) {
  const sub = [
    task.client_id == null ? he.tasks.internal : task.client_name,
    task.job_title,
    task.assigned_partner_name && `${he.board.assigneeLabel}: ${task.assigned_partner_name}`,
  ].filter(Boolean);

  return (
    <div className="list-head">
      <button type="button" className="icon-btn list-close" onClick={onClose} aria-label={he.common.close} title={he.common.close}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
          <path d={phone ? 'M9 6l6 6-6 6' : 'M6 6l12 12M18 6 6 18'} />
        </svg>
      </button>
      <div className="list-head-title">
        <h2>{task.title}</h2>
        <div className="list-head-sub">
          {task.locked && (
            <span className="badge green">{he.lists.doneOn} <DateText value={task.completed_at} /></span>
          )}
          {sub.map((s) => <span key={s}>{s}</span>)}
          {task.due_date && !task.locked && (
            <span>{he.board.due}: <DateText value={task.due_date} /></span>
          )}
        </div>
      </div>
      <div className="list-head-actions">
        {/* Printing works on a finished task's list too — that is often the one handed over. */}
        <Button small variant="subtle" onClick={onPrint}>{he.lists.print}</Button>
        {task.locked
          ? <Button small variant="subtle" onClick={onReopen}>{he.tasks.reopen}</Button>
          : (
            <>
              <Button small variant="subtle" onClick={onDefine}>{he.lists.definition}</Button>
              <Button small onClick={onDone}>{he.board.markDone}</Button>
            </>
          )}
      </div>
    </div>
  );
}
